import { NgModule } from "@angular/core";
import { MatButtonModule as MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule as MatListModule } from "@angular/material/list";
import { MatMenuModule as MatMenuModule } from "@angular/material/menu";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTabsModule as MatTabsModule } from "@angular/material/tabs";
import { MatAutocompleteModule as MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatNativeDateModule } from "@angular/material/core";
import { MatOptionModule as MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule as MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatCardModule as MatCardModule } from "@angular/material/card";
import { MatDialogModule as MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import { MatStepperModule } from "@angular/material/stepper";
import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule as MatRadioModule } from "@angular/material/radio";

@NgModule({
	exports: [
		MatButtonModule,
		MatExpansionModule,
		MatIconModule,
		MatListModule,
		MatMenuModule,
		MatSidenavModule,
		MatToolbarModule,
		MatProgressSpinnerModule,
		MatListModule,
		MatTabsModule,
		MatAutocompleteModule,
		MatOptionModule,
		MatFormFieldModule,
		MatInputModule,
		MatCardModule,
		MatDialogModule,
		MatIconModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatSelectModule,
		MatTooltipModule,
		MatStepperModule,
		MatCheckboxModule,
		MatRadioModule,
	],
})
export class MaterialModule {}
